import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-alert-api-400',
  templateUrl: './dialog-alert-api-400.component.html',
  styleUrls: ['./dialog-alert-api-400.component.sass']
})
export class DialogAlertApi400Component implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DialogAlertApi400Component>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
  }

  onClose() {
    this.dialogRef.close(true);
  }
}
